import { render } from "./LanguageChoiceComponent.vue?vue&type=template&id=5f92ce7d&scoped=true"
import script from "./LanguageChoiceComponent.vue?vue&type=script&lang=js"
export * from "./LanguageChoiceComponent.vue?vue&type=script&lang=js"

import "./LanguageChoiceComponent.vue?vue&type=style&index=0&id=5f92ce7d&lang=scss&scoped=true"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f92ce7d"]])

export default __exports__